import { component } from 'picoapp';
import Accordion from 'utils/accordion';

export default component(async (node) => {
  const { group } = node.dataset;
  const accordionParams = {
    toggleIcon: '.accordion__icon',
    ...(group ? { group, singular: true } : null),
  };
  Accordion(node, accordionParams);
});
